if (document.querySelector(".careers-index-page")) {
  var videos = document.querySelectorAll("video");
  if (videos) {
    Array.from(videos).forEach(function (video) {
      var videoUrl = video.getAttribute("src");
      if (!videoUrl || videoUrl.length < 55) return;
      var firstSection = videoUrl.slice(55);
      var secondSection = firstSection.split("/")[0];
      video.setAttribute(
        "poster",
        "https://vumbnail.com/" + secondSection + ".jpg"
      );
    });
  }
}
